import { useUserStore } from '@/stores/UserStore';
import useSettingsGlobals from '@/composables/useSettingsGlobals';
import useConfigurationGlobals from '@/composables/useConfigurationGlobals';
import Bugsnag from '@bugsnag/js';

const { $WEB_VIEW, $PLATFORM, $FEATURE_VERSION = 0 } = useSettingsGlobals()  ;
const { $BRAND } = useConfigurationGlobals()

export const useBugHandler = () => {
  const userStore = useUserStore();

  const report = (error, meta) => {

    Bugsnag.notify(error, (event) => {
      event.user = {
        memberLevel: userStore.memberLevel,
      }

      event.screenSize = `${window.innerWidth}x${window.innerHeight}`;
      event.webView = $WEB_VIEW;
      event.platform = $PLATFORM;
      event.featureVersion = $FEATURE_VERSION;
      event.brand = $BRAND;
      
      if (meta) {
        event.meta = meta;
      }
    });
    
  };

  return {
    report
  }
};
